import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */
/**
 * @type {import('$types/components/partials/modules.d.ts').Quote}
 */
const Quote = ({
    quote,
    author
}) => {
    // render
    return (
        <>
            <div className='sm-col-8'>
                <h2 className='type-style-1'>
                    {quote}
                </h2>
                {author &&
                    <p className='type-style-6 mt4'>
                        {author}
                    </p>
                }
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Quote;
